
import React, { Component } from 'react';
import { Dropdown, DropdownToggle, DropdownMenu, /*DropdownItem*/ } from 'reactstrap';
import { withRouter, Link } from 'react-router-dom';
import logo  from '../../../assets/images/logo_circle.png';
import dotenv from "dotenv"

dotenv.config()

class ProfileMenu extends Component {
    constructor(props) {
        super(props);
        this.state = {
            menu: false,
        };
        this.toggle = this.toggle.bind(this);
    }

    toggle() {
        this.setState(prevState => ({
            menu: !prevState.menu
        }));
    }

    render() {
        return (
            <React.Fragment>
                <Dropdown isOpen={this.state.menu} toggle={this.toggle} className="d-inline-block" >
                    <DropdownToggle className="btn header-item waves-effect" id="page-header-user-dropdown" tag="button">
                        <img className="rounded-circle header-profile-user" style={{backgroundColor: 'transparent'}} src={logo} alt="Bu Lurah Avatar"/>
                        <span className="d-none d-xl-inline-block ml-2 mr-1">Hi, Admin</span>
                        <i className="mdi mdi-chevron-down d-none d-xl-inline-block"></i>
                    </DropdownToggle>
                    <DropdownMenu right>
                        {/* <DropdownItem tag="a" href="/profile-detail"><i className="bx bx-user font-size-16 align-middle mr-1"></i>Profile</DropdownItem>
                        <DropdownItem tag="a" href="/change-password"><i className="bx bxs-key font-size-16 align-middle mr-1"></i>Change Password</DropdownItem>
                        <div className="dropdown-divider"></div> */}
                        <Link to="/logout" className="dropdown-item">
                            <i className="bx bx-power-off font-size-16 align-middle mr-1 text-danger"></i>
                            <span>Logout</span>
                        </Link>
                    </DropdownMenu>
                </Dropdown>
            </React.Fragment>
        );
    }
}

export default withRouter(ProfileMenu);


